import { FormField } from 'ui/formField';
import { TextInputField } from './components';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';
import { useCampaignQueryContext } from '../context/CampaignQueryContext';
import { useQueryParamContext } from '../context/QueryParamContext';
import { getIsEditMode } from './utils';
import { TemplateNameRestrictionText } from './RestrictionText';

const TemplateHelper = () => {
  const { campaign } = useCampaignQueryContext();

  return (
    <div>
      This name is specific to <b>{campaign.name}</b> content.
    </div>
  );
};

const MAX_TITLE_LENGTH = 100;

export const TemplateNameField = () => {
  const { isEditMode, liveTemplate, setCurrentTemplateField } = useEditableFieldsContext();
  const { view } = useQueryParamContext();
  const isEditModeVisible = getIsEditMode(view, isEditMode);

  const restrictionTextLabel = (
    <TemplateNameRestrictionText
      messageLength={liveTemplate.name.length}
      characterLimit={MAX_TITLE_LENGTH}
    />
  );

  return (
    <FormField
      data-test="template-name-field"
      labelText={'Template name'}
      helpText={isEditModeVisible ? <TemplateHelper /> : ''}
      restrictionText={restrictionTextLabel}
      isHorizontalLayout
    >
      <TextInputField
        mediumDataKey="templateName"
        mediumDataValue={liveTemplate.name}
        showSnippet={false}
        changeHandler={(content: string) => setCurrentTemplateField('name', content)}
        maxLength={MAX_TITLE_LENGTH}
      />
    </FormField>
  );
};
